var render = function render(){
  var _vm$selectedStockObje;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ModalContent', {
    attrs: {
      "flat-chrome": "",
      "help-content-id": "popup-catalog-".concat(_vm.current_entity_profile)
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm.catalog ? _c('template', {
    slot: "content"
  }, [_c('div', {
    staticClass: "stitch-modal general-settings-reference stitch-form"
  }, [_vm.catalog_saving ? _c('v-alert', {
    staticClass: "catalog-saving-alert mb-4",
    attrs: {
      "type": "info",
      "outlined": "",
      "prominent": ""
    }
  }, [_c('div', {
    staticClass: "d-flex align-center"
  }, [_c('v-progress-circular', {
    staticClass: "mr-4 flex-shrink-0",
    attrs: {
      "indeterminate": "",
      "color": "primary",
      "size": "28",
      "width": "3"
    }
  }), _c('div', [_c('div', {
    staticClass: "text-subtitle-2 font-weight-medium"
  }, [_vm._v(" " + _vm._s(_vm.savingTitle) + " ")]), _c('div', {
    staticClass: "text-body-2 grey--text text--darken-1 mb-0"
  }, [_vm._v(" " + _vm._s(_vm.savingMessage) + " ")])])], 1)]) : _vm._e(), _c('div', {
    staticClass: "catalog-modal-form stitch-modal__stack",
    "class": {
      'catalog-modal-form--saving': _vm.catalog_saving
    }
  }, [(_vm.stats.providers && _vm.isNew || _vm.catalog.provider) && !_vm.params.ownedOnly ? _c('v-card', {
    staticClass: "stitch-modal__card",
    attrs: {
      "elevation": "0"
    }
  }, [_c('v-card-text', [_c('h5', {
    staticClass: "stitch-modal__title"
  }, [_c('v-icon', {
    attrs: {
      "size": "16"
    }
  }, [_vm._v("mdi-domain")]), _c('span', [_vm._v(_vm._s(_vm.$translate("seller")))])], 1), _vm.isNew ? _c('p', [_vm._v(" " + _vm._s(_vm.$translate("sellerInstructions")) + " ")]) : _vm._e(), _c('v-row', [_c('v-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c('SearchProvider', {
    staticClass: "mt-0",
    attrs: {
      "outlined": "",
      "disabled": !_vm.isNew,
      "value": _vm.catalog.provider,
      "label": _vm.$translate('labels.seller'),
      "required": true,
      "dense": true,
      "error-messages": _vm.catalog_saving_errors.provider
    },
    on: {
      "select": _vm.updateProvider
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm.isConnectedSeller() ? [_c('Warning', {
    attrs: {
      "elevation": 2
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("connectedSellerInstructions")) + " ")])] : [_c('v-card', {
    staticClass: "stitch-modal__card",
    attrs: {
      "elevation": "0"
    }
  }, [_c('v-card-text', [_c('h5', {
    staticClass: "stitch-modal__title"
  }, [_c('v-icon', {
    attrs: {
      "size": "16"
    }
  }, [_vm._v("mdi-book-open-outline")]), _c('span', [_vm._v(_vm._s(_vm.$translate("informations")))])], 1), _c('v-row', {
    staticClass: "mt-2"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('label', {
    staticClass: "catalog-field-label",
    attrs: {
      "for": "catalog-name"
    }
  }, [_vm._v(" " + _vm._s(_vm.requiredLabel(_vm.$translate("labels.name"))) + " ")]), _c('v-text-field', {
    attrs: {
      "outlined": "",
      "id": "catalog-name",
      "required": "",
      "hide-details": "auto",
      "error-messages": _vm.catalog_saving_errors.name,
      "autofocus": true,
      "dense": true
    },
    model: {
      value: _vm.catalog.name,
      callback: function callback($$v) {
        _vm.$set(_vm.catalog, "name", $$v);
      },
      expression: "catalog.name"
    }
  })], 1), _vm.isNew && _vm.stats.catalogs ? [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('SearchCatalog', {
    key: _vm.catalog.provider,
    attrs: {
      "outlined": "",
      "value": _vm.catalog.copy_from,
      "dense": true,
      "label": _vm.$translate('labels.copyFrom'),
      "additional-params": _vm.getCatalogsParams()
    },
    on: {
      "select": _vm.catalogSelected
    }
  })], 1)] : _vm._e()], 2), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('label', {
    staticClass: "catalog-field-label",
    attrs: {
      "for": "catalog-vat"
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("labels.forceVatRate").replace("{vat}", _vm.defaultVatRate)) + " ")]), _c('v-text-field', {
    attrs: {
      "outlined": "",
      "value": _vm.forceVatRate,
      "type": "text",
      "inputmode": "decimal",
      "id": "catalog-vat",
      "clearable": "",
      "dense": "",
      "hide-details": "auto",
      "error-messages": _vm.catalog_saving_errors.forceVatRate
    },
    on: {
      "input": function input($event) {
        _vm.catalog.force_vat_rate = $event ? _vm.decimal(_vm.$utils.normalizeDecimalString($event)).dividedBy(100).toString() : null;
      }
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('label', {
    staticClass: "catalog-field-label",
    attrs: {
      "for": "catalog-price-type"
    }
  }, [_vm._v(" " + _vm._s(_vm.requiredLabel(_vm.$translate("labels.priceType"))) + " ")]), _c('v-select', {
    attrs: {
      "outlined": "",
      "dense": true,
      "id": "catalog-price-type",
      "items": _vm.priceTypeItems,
      "placeholder": _vm.isNew ? _vm.$translate('labels.selectPriceType') : undefined,
      "clearable": false,
      "hide-details": "auto",
      "error-messages": _vm.pricesIncludeVatErrors
    },
    on: {
      "blur": function blur($event) {
        _vm.pricesIncludeVatTouched = true;
      }
    },
    model: {
      value: _vm.catalog.prices_include_vat,
      callback: function callback($$v) {
        _vm.$set(_vm.catalog, "prices_include_vat", $$v);
      },
      expression: "catalog.prices_include_vat"
    }
  })], 1)], 1), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('label', {
    staticClass: "catalog-field-label",
    attrs: {
      "for": "catalog-margin"
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("labels.targetMarginPercent")) + " "), _c('StitchHint', {
    attrs: {
      "hint": _vm.$translate('labels.targetMarginPercentHint')
    }
  })], 1), _c('v-text-field', {
    attrs: {
      "outlined": "",
      "type": "text",
      "inputmode": "decimal",
      "id": "catalog-margin",
      "dense": "",
      "hide-details": "auto",
      "error-messages": _vm.catalog_saving_errors.target_margin_percent
    },
    model: {
      value: _vm.targetMarginPercentDisplay,
      callback: function callback($$v) {
        _vm.targetMarginPercentDisplay = $$v;
      },
      expression: "targetMarginPercentDisplay"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('label', {
    staticClass: "catalog-field-label",
    attrs: {
      "for": "catalog-commission"
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("labels.agentCommissionPercent")) + " "), _c('StitchHint', {
    attrs: {
      "hint": _vm.$translate('labels.agentCommissionPercentHint')
    }
  })], 1), _c('v-text-field', {
    attrs: {
      "outlined": "",
      "type": "text",
      "inputmode": "decimal",
      "id": "catalog-commission",
      "dense": "",
      "hide-details": "auto",
      "error-messages": _vm.catalog_saving_errors.agent_commission_percent
    },
    model: {
      value: _vm.agentCommissionPercentDisplay,
      callback: function callback($$v) {
        _vm.agentCommissionPercentDisplay = $$v;
      },
      expression: "\n                                            agentCommissionPercentDisplay\n                                        "
    }
  })], 1)], 1), _c('v-row', [_vm.isNew ? [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('label', {
    staticClass: "catalog-field-label",
    attrs: {
      "for": "catalog-default"
    }
  }, [_vm._v(" " + _vm._s(_vm.requiredLabel(_vm.$translate("labels.assignToNewCustomers"))) + " "), _c('StitchHint', {
    attrs: {
      "hint": _vm.$translate('labels.assignToNewCustomersHint')
    }
  })], 1), _c('v-select', {
    attrs: {
      "outlined": "",
      "dense": true,
      "id": "catalog-default",
      "items": _vm.yesNoItems,
      "placeholder": _vm.$translate('labels.selectYesNo'),
      "clearable": false,
      "hide-details": "auto",
      "error-messages": _vm.defaultCatalogErrors
    },
    on: {
      "blur": function blur($event) {
        _vm.defaultCatalogTouched = true;
      }
    },
    model: {
      value: _vm.catalog["default"],
      callback: function callback($$v) {
        _vm.$set(_vm.catalog, "default", $$v);
      },
      expression: "catalog.default"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('label', {
    staticClass: "catalog-field-label",
    attrs: {
      "for": "catalog-auto-products"
    }
  }, [_vm._v(" " + _vm._s(_vm.requiredLabel(_vm.autoAddProductsLabel)) + " "), _c('StitchHint', {
    attrs: {
      "hint": _vm.autoAddProductsHint
    }
  })], 1), _c('v-select', {
    attrs: {
      "outlined": "",
      "dense": true,
      "id": "catalog-auto-products",
      "items": _vm.yesNoItems,
      "placeholder": _vm.$translate('labels.selectYesNo'),
      "clearable": false,
      "hide-details": "auto",
      "error-messages": _vm.autoAddProductsErrors
    },
    on: {
      "blur": function blur($event) {
        _vm.autoAddProductsTouched = true;
      }
    },
    model: {
      value: _vm.catalog.auto_add_products,
      callback: function callback($$v) {
        _vm.$set(_vm.catalog, "auto_add_products", $$v);
      },
      expression: "\n                                                catalog.auto_add_products\n                                            "
    }
  })], 1)] : _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": _vm.$translate('labels.defaultCatalog'),
      "dense": "",
      "hide-details": "",
      "error-messages": _vm.catalog_saving_errors["default"]
    },
    model: {
      value: _vm.catalog["default"],
      callback: function callback($$v) {
        _vm.$set(_vm.catalog, "default", $$v);
      },
      expression: "catalog.default"
    }
  }), _c('v-checkbox', {
    attrs: {
      "label": _vm.$translate('labels.autoAddProducts'),
      "dense": "",
      "hide-details": "",
      "error-messages": _vm.catalog_saving_errors.auto_add_products
    },
    model: {
      value: _vm.catalog.auto_add_products,
      callback: function callback($$v) {
        _vm.$set(_vm.catalog, "auto_add_products", $$v);
      },
      expression: "catalog.auto_add_products"
    }
  })], 1)], 2)], 1)], 1), _c('v-card', {
    staticClass: "stitch-modal__card",
    attrs: {
      "elevation": "0"
    }
  }, [_c('v-card-text', [_c('h5', {
    staticClass: "stitch-modal__title"
  }, [_c('v-icon', {
    attrs: {
      "size": "16"
    }
  }, [_vm._v("mdi-warehouse")]), _c('span', [_vm._v(_vm._s(_vm.$translate("labels.restrictToStocks")))])], 1), _c('p', {
    staticClass: "text-caption mb-0"
  }, [_vm._v(" " + _vm._s(_vm.$translate("labels.restrictToStocksHint")) + " ")]), _c('v-row', {
    staticClass: "mt-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_vm.selectedStocks.length > 0 ? _c('v-list', {
    staticClass: "pa-0 mb-2",
    attrs: {
      "dense": ""
    }
  }, [_c('draggable', {
    attrs: {
      "handle": ".drag-handle"
    },
    on: {
      "end": _vm.updateStocksOrder
    },
    model: {
      value: _vm.selectedStocks,
      callback: function callback($$v) {
        _vm.selectedStocks = $$v;
      },
      expression: "selectedStocks"
    }
  }, _vm._l(_vm.selectedStocks, function (stock, index) {
    return _c('v-list-item', {
      key: stock.id,
      staticClass: "stock-item mb-2",
      staticStyle: {
        "border": "1px solid",
        "border-radius": "4px",
        "min-height": "40px",
        "height": "40px"
      }
    }, [_c('v-list-item-icon', {
      staticClass: "drag-handle my-0 mr-2",
      staticStyle: {
        "cursor": "move",
        "align-self": "center"
      }
    }, [_c('v-icon', {
      attrs: {
        "size": "20"
      }
    }, [_vm._v("mdi-drag")])], 1), _c('v-list-item-content', {
      staticClass: "py-0"
    }, [_c('v-list-item-title', {
      staticStyle: {
        "line-height": "1.2"
      }
    }, [_vm._v(" " + _vm._s(_vm.getStockName(stock)) + " ")])], 1), _c('div', {
      staticClass: "text-caption grey--text mr-3",
      staticStyle: {
        "align-self": "center",
        "white-space": "nowrap"
      }
    }, [_vm._v(" " + _vm._s(_vm.$translate("labels.priority")) + ": " + _vm._s(index + 1) + " ")]), _c('v-list-item-action', {
      staticClass: "my-0",
      staticStyle: {
        "align-self": "center"
      }
    }, [_c('v-btn', {
      attrs: {
        "icon": "",
        "x-small": ""
      },
      on: {
        "click": function click($event) {
          return _vm.removeStock(stock);
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("mdi-delete")])], 1)], 1)], 1);
  }), 1)], 1) : _vm._e(), _c('label', {
    staticClass: "catalog-field-label",
    attrs: {
      "for": "catalog-stock"
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("labels.addStock")) + " ")]), _c('v-combobox', {
    key: (_vm$selectedStockObje = _vm.selectedStockObject) === null || _vm$selectedStockObje === void 0 ? void 0 : _vm$selectedStockObje.id,
    staticClass: "mt-2",
    attrs: {
      "items": _vm.availableStocks,
      "item-text": _vm.getStockName,
      "item-value": "id",
      "id": "catalog-stock",
      "loading": _vm.stocksLoading,
      "search-input": _vm.stockSearchInput,
      "hide-selected": "",
      "dense": "",
      "clearable": "",
      "outlined": ""
    },
    on: {
      "update:searchInput": function updateSearchInput($event) {
        _vm.stockSearchInput = $event;
      },
      "update:search-input": function updateSearchInput($event) {
        _vm.stockSearchInput = $event;
      },
      "change": _vm.addStock,
      "click:clear": function clickClear($event) {
        _vm.selectedStockObject = null;
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.getStockName(item)))])], 1)];
      }
    }, {
      key: "no-data",
      fn: function fn() {
        return [_c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.getNoDataMessage()) + " ")])], 1)], 1)];
      },
      proxy: true
    }], null, false, 290014620),
    model: {
      value: _vm.selectedStockObject,
      callback: function callback($$v) {
        _vm.selectedStockObject = $$v;
      },
      expression: "selectedStockObject"
    }
  })], 1)], 1)], 1)], 1)]], 2)], 1)]) : _vm._e(), _c('template', {
    slot: "bottom"
  }, [_c('v-btn', {
    staticClass: "my-2 my-sm-4 w-100 w-sm-auto",
    attrs: {
      "text": "",
      "disabled": _vm.catalog_saving
    },
    on: {
      "click": _vm.cancelEditClicked
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("cancel")) + " ")]), _c('v-btn', {
    staticClass: "my-2 my-sm-4 w-100 w-sm-auto ml-sm-3",
    attrs: {
      "color": "primary",
      "disabled": !_vm.readyforsave || _vm.isConnectedSeller(),
      "loading": _vm.catalog_saving
    },
    on: {
      "click": _vm.saveInformationClicked
    }
  }, [_vm._v(" " + _vm._s(_vm.saveText) + " ")])], 1)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }